export default __webpack_public_path__ + "static/media/SA_Templates_M4.83548ea2.pdf";